import MenuWidget, { ConnectedMenuWidget } from "./MenuWidget";
import type { MenuWidgetProps } from "./MenuWidget";

export { ConnectedMenuWidget, MenuWidgetProps };
export default MenuWidget;
